export default __webpack_public_path__ + "static/media/1.bf5e0afe.svg";